import { render, staticRenderFns } from "./CustomDetails.vue?vue&type=template&id=00e88ceb&scoped=true&"
import script from "./CustomDetails.vue?vue&type=script&lang=js&"
export * from "./CustomDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomDetails.vue?vue&type=style&index=0&id=00e88ceb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e88ceb",
  null
  
)

export default component.exports